import { render, staticRenderFns } from "./trainingsAnnouncementView.vue?vue&type=template&id=49a2cb04"
import script from "./trainingsAnnouncementView.vue?vue&type=script&lang=js"
export * from "./trainingsAnnouncementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports